import { useState, useEffect } from 'react'
import { saLogin, saDashboard, saOrgaos, saOrgao, saCriarOrgao, saAtualizarOrgao, saSuspender, saReativar, saCriarAdmin } from '../../services/superadmin'

const PLANOS = {
  basico:       { label:'Básico',       cor:'#185FA5', bg:'#E6F1FB', preco:'R$ 297/mês' },
  profissional: { label:'Profissional', cor:'#3B6D11', bg:'#EAF3DE', preco:'R$ 597/mês' },
  enterprise:   { label:'Enterprise',   cor:'#534AB7', bg:'#EEEDFE', preco:'R$ 997/mês' },
}
const TIPOS = { prefeitura:'🏛 Prefeitura', camara:'🏛 Câmara Municipal', autarquia:'🏢 Autarquia', outro:'📋 Outro' }
const ESTADOS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO']

// ── Componentes fora do componente pai para evitar perda de foco ──

function Badge({ children, bg, cor }) {
  return <span style={{ background:bg, color:cor, padding:'2px 10px', borderRadius:99, fontSize:11, fontWeight:500, whiteSpace:'nowrap' }}>{children}</span>
}

function Metric({ label, valor, cor }) {
  return (
    <div style={{ background:'#f9fafb', borderRadius:8, padding:'14px 16px' }}>
      <div style={{ fontSize:12, color:'#9ca3af', marginBottom:4 }}>{label}</div>
      <div style={{ fontSize:26, fontWeight:500, color:cor||'#111' }}>{valor}</div>
    </div>
  )
}

function ModalOrgao({ modal, orgaoAtivo, form, onChange, onSalvar, onFechar, erro, load, estados }) {
  if (!modal || (modal !== 'novo' && modal !== 'editar')) return null
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'white', borderRadius:12, width:'100%', maxWidth:600, maxHeight:'90vh', overflow:'auto' }}>
        <div style={{ padding:'16px 20px', borderBottom:'1px solid #e5e7eb', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:15, fontWeight:500 }}>{modal==='novo'?'Novo órgão cliente':'Editar órgão'}</div>
          <button onClick={onFechar} style={{ background:'none', border:'none', fontSize:18, cursor:'pointer', color:'#9ca3af' }}>✕</button>
        </div>
        <div style={{ padding:20 }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
            <div style={{ gridColumn:'1/-1' }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Nome do órgão *</label>
              <input value={form.nome||''} onChange={e=>onChange('nome',e.target.value)} placeholder="Prefeitura Municipal de..."
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Município *</label>
              <input value={form.municipio||''} onChange={e=>onChange('municipio',e.target.value)} placeholder="Nome da cidade"
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Estado *</label>
              <select value={form.estado||''} onChange={e=>onChange('estado',e.target.value)} style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
                <option value="">UF</option>{estados.map(e=><option key={e} value={e}>{e}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Tipo de órgão</label>
              <select value={form.tipo_orgao||'prefeitura'} onChange={e=>onChange('tipo_orgao',e.target.value)} style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
                {Object.entries(TIPOS).map(([k,v])=><option key={k} value={k}>{v}</option>)}
              </select>
            </div>
            {modal==='novo' && (
              <div style={{ gridColumn:'1/-1' }}>
                <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Identificador (slug) *</label>
                <input value={form.slug||''} onChange={e=>onChange('slug',e.target.value.toLowerCase().replace(/[^a-z0-9-]/g,''))} placeholder="ex: santarosa"
                  style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, fontFamily:'monospace', boxSizing:'border-box' }} />
                <div style={{ fontSize:11, color:'#9ca3af', marginTop:3 }}>Só letras minúsculas e hífens.</div>
              </div>
            )}
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Plano</label>
              <select value={form.plano||'basico'} onChange={e=>onChange('plano',e.target.value)} style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
                {Object.entries(PLANOS).map(([k,v])=><option key={k} value={k}>{v.label} — {v.preco}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Valor mensalidade (R$)</label>
              <input type="number" value={form.valor_mensalidade||''} onChange={e=>onChange('valor_mensalidade',e.target.value)} placeholder="297"
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Limite processos/mês</label>
              <input type="number" value={form.limite_processos||500} onChange={e=>onChange('limite_processos',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Limite de usuários</label>
              <input type="number" value={form.limite_usuarios||50} onChange={e=>onChange('limite_usuarios',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div style={{ gridColumn:'1/-1', paddingTop:8, borderTop:'1px solid #f3f4f6' }}>
              <div style={{ fontSize:12, fontWeight:500, color:'#374151', marginBottom:10 }}>Contato do responsável</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Nome</label>
                  <input value={form.contato_nome||''} onChange={e=>onChange('contato_nome',e.target.value)} placeholder="Nome do responsável"
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, boxSizing:'border-box' }} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>E-mail</label>
                  <input value={form.contato_email||''} onChange={e=>onChange('contato_email',e.target.value)} placeholder="email@prefeitura.gov.br"
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, boxSizing:'border-box' }} />
                </div>
                <div>
                  <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Telefone</label>
                  <input value={form.contato_telefone||''} onChange={e=>onChange('contato_telefone',e.target.value)} placeholder="(00) 00000-0000"
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:12, boxSizing:'border-box' }} />
                </div>
              </div>
            </div>
          </div>
          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:13, color:'#dc2626', margin:'12px 0' }}>{erro}</div>}
          <div style={{ display:'flex', gap:8, marginTop:16 }}>
            <button onClick={onSalvar} disabled={load} style={{ flex:1, padding:10, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
              {load?'Salvando...':modal==='novo'?'Criar órgão':'Salvar alterações'}
            </button>
            <button onClick={onFechar} style={{ padding:'10px 16px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  )
}

function ModalAdmin({ aberto, orgaoAtivo, form, onChange, onSalvar, onFechar, erro, load }) {
  if (!aberto) return null
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'white', borderRadius:12, width:'100%', maxWidth:420 }}>
        <div style={{ padding:'16px 20px', borderBottom:'1px solid #e5e7eb', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:15, fontWeight:500 }}>Criar administrador</div>
          <button onClick={onFechar} style={{ background:'none', border:'none', fontSize:18, cursor:'pointer', color:'#9ca3af' }}>✕</button>
        </div>
        <div style={{ padding:20 }}>
          <div style={{ fontSize:13, color:'#9ca3af', marginBottom:16 }}>Crie o usuário administrador para <strong>{orgaoAtivo?.nome}</strong>.</div>
          {[['nome','Nome completo *','Nome do administrador'],['email','E-mail *','admin@prefeitura.gov.br'],['senha','Senha temporária *','Mínimo 8 caracteres']].map(([k,l,p])=>(
            <div key={k} style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>{l}</label>
              <input type={k==='senha'?'password':'text'} value={form[k]||''} onChange={e=>onChange(k,e.target.value)} placeholder={p}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
          ))}
          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:13, color:'#dc2626', marginBottom:12 }}>{erro}</div>}
          <button onClick={onSalvar} disabled={load} style={{ width:'100%', padding:10, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            {load?'Criando...':'Criar administrador'}
          </button>
        </div>
      </div>
    </div>
  )
}

function ModalSuspender({ aberto, orgaoAtivo, motivo, onChangeMotivo, onSalvar, onFechar, erro }) {
  if (!aberto) return null
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'white', borderRadius:12, width:'100%', maxWidth:420, padding:24 }}>
        <div style={{ fontSize:15, fontWeight:500, marginBottom:14 }}>Suspender acesso</div>
        <div style={{ fontSize:13, color:'#374151', marginBottom:14 }}>
          O órgão <strong>{orgaoAtivo?.nome}</strong> perderá acesso até ser reativado.
        </div>
        <div style={{ marginBottom:14 }}>
          <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Motivo da suspensão *</label>
          <textarea value={motivo} onChange={e=>onChangeMotivo(e.target.value)} placeholder="Ex: Inadimplência..."
            style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, minHeight:80, resize:'vertical', boxSizing:'border-box' }} />
        </div>
        {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:13, color:'#dc2626', marginBottom:12 }}>{erro}</div>}
        <div style={{ display:'flex', gap:8 }}>
          <button onClick={onSalvar} style={{ flex:1, padding:10, background:'#A32D2D', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>Suspender</button>
          <button onClick={onFechar} style={{ padding:'10px 16px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>Cancelar</button>
        </div>
      </div>
    </div>
  )
}

function SaLayout({ saUser, tela, onNav, onSair, children }) {
  return (
    <div style={{ display:'flex', minHeight:'100vh', fontFamily:'system-ui,sans-serif', background:'#f0f4f8' }}>
      <aside style={{ width:220, background:'#0f172a', display:'flex', flexDirection:'column', flexShrink:0 }}>
        <div style={{ padding:'20px 16px', borderBottom:'1px solid #1e293b' }}>
          <div style={{ fontSize:16, fontWeight:700, color:'white' }}>Proto<span style={{ color:'#60a5fa' }}>Gov</span></div>
          <div style={{ fontSize:11, color:'#64748b', marginTop:3 }}>SuperAdmin — WE Sistemas</div>
        </div>
        <nav style={{ padding:8, flex:1 }}>
          {[{label:'Dashboard',key:'dashboard',icone:'▦'},{label:'Órgãos clientes',key:'orgaos',icone:'🏛'}].map(item=>(
            <div key={item.key} onClick={()=>onNav(item.key)} style={{ padding:'8px 10px', borderRadius:8, cursor:'pointer', fontSize:13, marginBottom:2, background:tela===item.key?'#1e3a5f':'transparent', color:tela===item.key?'#60a5fa':'#94a3b8', display:'flex', alignItems:'center', gap:8 }}>
              <span>{item.icone}</span>{item.label}
            </div>
          ))}
        </nav>
        <div style={{ padding:12, borderTop:'1px solid #1e293b' }}>
          <div style={{ fontSize:12, color:'#94a3b8' }}>{saUser?.nome}</div>
          <div onClick={onSair} style={{ fontSize:12, color:'#ef4444', cursor:'pointer', marginTop:4 }}>Sair</div>
        </div>
      </aside>
      <main style={{ flex:1, padding:24, overflowY:'auto' }}>{children}</main>
    </div>
  )
}

export default function SuperAdmin() {
  const [tela, setTela] = useState('login')
  const [saUser, setSaUser] = useState(null)
  const [dashboard, setDashboard] = useState(null)
  const [orgaos, setOrgaos] = useState([])
  const [orgaoAtivo, setOrgaoAtivo] = useState(null)
  const [detalhe, setDetalhe] = useState(null)
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState({})
  const [motivo, setMotivo] = useState('')
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')
  const [load, setLoad] = useState(false)
  const [busca, setBusca] = useState('')
  const [loginEmail, setLoginEmail] = useState('')
  const [loginSenha, setLoginSenha] = useState('')
  const [loginErro, setLoginErro] = useState('')
  const [loginLoad, setLoginLoad] = useState(false)
  const [modalEditAdmin, setModalEditAdmin] = useState(null)
  const [senhaGerada, setSenhaGerada] = useState(null)

  useEffect(() => {
    const token = localStorage.getItem('sa_token')
    const user = localStorage.getItem('sa_user')
    if (token && user) { setSaUser(JSON.parse(user)); setTela('dashboard'); carregarTudo() }
  }, [])

  async function carregarTudo() {
    try {
      const [dash, lista] = await Promise.all([saDashboard(), saOrgaos()])
      setDashboard(dash.data); setOrgaos(lista.data)
    } catch {}
  }

  async function verDetalhe(orgao) {
    setOrgaoAtivo(orgao); setTela('detalhe'); setDetalhe(null)
    try { const r = await saOrgao(orgao.id); setDetalhe(r.data) } catch {}
  }

  function onChange(k, v) { setForm(f => ({...f,[k]:v})) }

  async function fazerLogin(e) {
    e.preventDefault(); setLoginErro(''); setLoginLoad(true)
    try {
      const r = await saLogin(loginEmail, loginSenha)
      localStorage.setItem('sa_token', r.data.token)
      localStorage.setItem('sa_user', JSON.stringify(r.data.superadmin))
      setSaUser(r.data.superadmin); setTela('dashboard'); carregarTudo()
    } catch(e) { setLoginErro(e.response?.data?.erro || 'Credenciais inválidas') }
    finally { setLoginLoad(false) }
  }

  async function editarAdmin(usuario) {
    setModalEditAdmin(usuario)
    setForm({ nome: usuario.nome, email: usuario.email })
    setErro('')
  }

  async function salvarEdicaoAdmin() {
    setErro(''); setLoad(true)
    try {
      const { saEditarAdmin } = await import('../../services/superadmin')
      await saEditarAdmin(orgaoAtivo.id, modalEditAdmin.id, form)
      setSucesso('Usuário atualizado!'); setModalEditAdmin(null); setForm({})
      const r = await saOrgao(orgaoAtivo.id); setDetalhe(r.data)
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro') }
    finally { setLoad(false) }
  }

  async function excluirAdmin(userId) {
    if (!window.confirm('Desativar este usuário?')) return
    try {
      const { saExcluirAdmin } = await import('../../services/superadmin')
      await saExcluirAdmin(orgaoAtivo.id, userId)
      setSucesso('Usuário desativado!'); const r = await saOrgao(orgaoAtivo.id); setDetalhe(r.data)
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { alert(e.response?.data?.erro || 'Erro') }
  }

  async function resetarSenhaAdmin(userId) {
    if (!window.confirm('Resetar senha deste usuário?')) return
    try {
      const { saResetarSenha } = await import('../../services/superadmin')
      const r = await saResetarSenha(orgaoAtivo.id, userId)
      setSenhaGerada(r.data.senha_provisoria)
    } catch(e) { alert(e.response?.data?.erro || 'Erro') }
  }

  async function salvarOrgao() {
    setErro(''); setLoad(true)
    try {
      if (modal==='novo') { await saCriarOrgao(form); setSucesso('Órgão criado!') }
      else { await saAtualizarOrgao(orgaoAtivo.id, form); setSucesso('Órgão atualizado!') }
      setModal(null); setForm({}); carregarTudo()
      if (orgaoAtivo) { const r = await saOrgao(orgaoAtivo.id); setDetalhe(r.data) }
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao salvar') }
    finally { setLoad(false) }
  }

  async function salvarAdmin() {
    setErro(''); setLoad(true)
    try {
      await saCriarAdmin(orgaoAtivo.id, form)
      setSucesso('Administrador criado!'); setModal(null); setForm({})
      const r = await saOrgao(orgaoAtivo.id); setDetalhe(r.data)
      setTimeout(() => setSucesso(''), 4000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro') }
    finally { setLoad(false) }
  }

  async function suspender() {
    if (!motivo) { setErro('Informe o motivo'); return }
    try { await saSuspender(orgaoAtivo.id, motivo); setModal(null); setMotivo(''); carregarTudo(); const r = await saOrgao(orgaoAtivo.id); setDetalhe(r.data) } catch {}
  }

  async function reativar(id) {
    if (!window.confirm('Reativar este órgão?')) return
    try { await saReativar(id); carregarTudo(); if(orgaoAtivo){const r=await saOrgao(orgaoAtivo.id);setDetalhe(r.data)} } catch {}
  }

  function sair() { localStorage.removeItem('sa_token'); localStorage.removeItem('sa_user'); setSaUser(null); setTela('login') }

  const orgaosFiltrados = orgaos.filter(o => !busca || o.nome.toLowerCase().includes(busca.toLowerCase()) || o.municipio.toLowerCase().includes(busca.toLowerCase()))

  if (tela==='login') return (
    <div style={{ minHeight:'100vh', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui,sans-serif' }}>
      <div style={{ background:'#1e293b', borderRadius:12, border:'1px solid #334155', padding:40, width:'100%', maxWidth:380 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:24, fontWeight:700, color:'white' }}>Proto<span style={{ color:'#60a5fa' }}>Gov</span></div>
          <div style={{ fontSize:13, color:'#64748b', marginTop:4 }}>Painel SuperAdmin · WE Sistemas</div>
        </div>
        <form onSubmit={fazerLogin}>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#94a3b8' }}>E-mail</label>
            <input type="email" value={loginEmail} onChange={e=>setLoginEmail(e.target.value)} required placeholder="admin@wesistemas.com.br"
              style={{ width:'100%', padding:'10px 12px', border:'1px solid #334155', borderRadius:8, fontSize:13, background:'#0f172a', color:'white', boxSizing:'border-box' }} />
          </div>
          <div style={{ marginBottom:20 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#94a3b8' }}>Senha</label>
            <input type="password" value={loginSenha} onChange={e=>setLoginSenha(e.target.value)} required placeholder="••••••••"
              style={{ width:'100%', padding:'10px 12px', border:'1px solid #334155', borderRadius:8, fontSize:13, background:'#0f172a', color:'white', boxSizing:'border-box' }} />
          </div>
          {loginErro && <div style={{ background:'#450a0a', border:'1px solid #7f1d1d', borderRadius:8, padding:10, fontSize:13, color:'#fca5a5', marginBottom:12 }}>{loginErro}</div>}
          <button type="submit" disabled={loginLoad} style={{ width:'100%', padding:11, background:'#2563eb', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer', fontWeight:500 }}>
            {loginLoad?'Entrando...':'Entrar'}
          </button>
        </form>
      </div>
    </div>
  )

  return (
    <SaLayout saUser={saUser} tela={tela==='detalhe'?'orgaos':tela} onNav={setTela} onSair={sair}>
      {/* Modal editar admin */}
      {modalEditAdmin && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div style={{ background:'white', borderRadius:12, width:'100%', maxWidth:400, padding:24 }}>
            <div style={{ fontSize:15, fontWeight:500, marginBottom:16 }}>Editar usuário</div>
            <div style={{ marginBottom:12 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Nome</label>
              <input value={form.nome||''} onChange={e=>onChange('nome',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>E-mail</label>
              <input value={form.email||''} onChange={e=>onChange('email',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
            </div>
            {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:13, color:'#dc2626', marginBottom:12 }}>{erro}</div>}
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={salvarEdicaoAdmin} disabled={load} style={{ flex:1, padding:10, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                {load?'Salvando...':'Salvar'}
              </button>
              <button onClick={() => { setModalEditAdmin(null); setForm({}); setErro('') }} style={{ padding:'10px 16px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Senha gerada */}
      {senhaGerada && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div style={{ background:'white', borderRadius:12, padding:24, maxWidth:380, width:'100%' }}>
            <div style={{ fontSize:15, fontWeight:500, marginBottom:12 }}>🔑 Senha provisória gerada</div>
            <div style={{ background:'#f9fafb', borderRadius:8, padding:14, textAlign:'center', marginBottom:16 }}>
              <div style={{ fontSize:24, fontFamily:'monospace', fontWeight:700, color:'#185FA5', letterSpacing:2 }}>{senhaGerada}</div>
            </div>
            <div style={{ fontSize:12, color:'#6b7280', marginBottom:16 }}>Entregue esta senha ao administrador. Ele será obrigado a trocar no próximo acesso.</div>
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={() => navigator.clipboard.writeText(senhaGerada)} style={{ flex:1, padding:10, border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>📋 Copiar</button>
              <button onClick={() => setSenhaGerada(null)} style={{ flex:1, padding:10, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer' }}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      <ModalOrgao modal={modal==='novo'||modal==='editar'?modal:null} orgaoAtivo={orgaoAtivo} form={form} onChange={onChange} onSalvar={salvarOrgao} onFechar={()=>{setModal(null);setForm({});setErro('')}} erro={erro} load={load} estados={ESTADOS} />
      <ModalAdmin aberto={modal==='admin'} orgaoAtivo={orgaoAtivo} form={form} onChange={onChange} onSalvar={salvarAdmin} onFechar={()=>{setModal(null);setForm({});setErro('')}} erro={erro} load={load} />
      <ModalSuspender aberto={modal==='suspender'} orgaoAtivo={orgaoAtivo} motivo={motivo} onChangeMotivo={setMotivo} onSalvar={suspender} onFechar={()=>{setModal(null);setMotivo('');setErro('')}} erro={erro} />

      {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}

      {tela==='dashboard' && <>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <h1 style={{ fontSize:18, fontWeight:500, margin:0 }}>Dashboard</h1>
          <button onClick={()=>{setModal('novo');setForm({plano:'basico',limite_processos:500,limite_usuarios:50,vencimento_dia:10,tipo_orgao:'prefeitura'})}}
            style={{ padding:'8px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            + Novo órgão cliente
          </button>
        </div>
        {dashboard && <>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:24 }}>
            <Metric label="Órgãos ativos" valor={dashboard.total_orgaos} />
            <Metric label="Total processos" valor={dashboard.total_processos?.toLocaleString('pt-BR')} />
            <Metric label="Usuários" valor={dashboard.total_usuarios?.toLocaleString('pt-BR')} />
            <Metric label="Processos hoje" valor={dashboard.processos_hoje} cor="#185FA5" />
          </div>
          {dashboard.alertas_sem_atendimento?.length > 0 && (
            <div style={{ background:'white', borderRadius:12, border:'1px solid #fecaca', padding:20, marginBottom:20 }}>
              <div style={{ fontSize:14, fontWeight:500, color:'#dc2626', marginBottom:12 }}>⚠️ Processos sem atendimento há mais de 7 dias</div>
              {dashboard.alertas_sem_atendimento.map(o => (
                <div key={o.id} onClick={()=>verDetalhe(o)} style={{ display:'flex', alignItems:'center', gap:12, padding:'8px 0', borderBottom:'1px solid #f3f4f6', cursor:'pointer' }}>
                  <div style={{ flex:1 }}><div style={{ fontSize:13, fontWeight:500 }}>{o.nome}</div><div style={{ fontSize:11, color:'#9ca3af' }}>{o.municipio}</div></div>
                  <span style={{ background:'#fef2f2', color:'#dc2626', padding:'2px 10px', borderRadius:99, fontSize:11, fontWeight:500 }}>{o.processos_abertos} abertos</span>
                </div>
              ))}
            </div>
          )}
        </>}
        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <div style={{ fontSize:14, fontWeight:500 }}>Órgãos clientes</div>
            <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="Buscar..." style={{ padding:'7px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, width:200 }} />
          </div>
          {orgaosFiltrados.length===0
            ?<div style={{ textAlign:'center', padding:32, color:'#9ca3af', fontSize:14 }}>Nenhum órgão cadastrado.</div>
            :orgaosFiltrados.map((o,i)=>{
              const plano=PLANOS[o.plano]||PLANOS.basico
              return(
                <div key={o.id} onClick={()=>verDetalhe(o)} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 0', borderBottom:i<orgaosFiltrados.length-1?'1px solid #f3f4f6':'none', cursor:'pointer' }}
                  onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  <div style={{ width:40, height:40, borderRadius:8, background:'#E6F1FB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:'#185FA5', flexShrink:0 }}>{o.estado}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13, fontWeight:500 }}>{o.nome}</div>
                    <div style={{ fontSize:11, color:'#9ca3af' }}>{o.municipio}/{o.estado} · {o.total_usuarios} usuários · {o.total_processos} processos</div>
                  </div>
                  <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                    {o.processos_atrasados>0&&<span style={{ background:'#fef2f2', color:'#dc2626', padding:'2px 8px', borderRadius:99, fontSize:10, fontWeight:500 }}>⚠️ {o.processos_atrasados}</span>}
                    {o.suspensa&&<span style={{ background:'#FCEBEB', color:'#791F1F', padding:'2px 8px', borderRadius:99, fontSize:10, fontWeight:500 }}>Suspenso</span>}
                    <Badge bg={plano.bg} cor={plano.cor}>{plano.label}</Badge>
                  </div>
                </div>
              )
            })
          }
        </div>
      </>}

      {tela==='orgaos' && <>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <h1 style={{ fontSize:18, fontWeight:500, margin:0 }}>Órgãos clientes</h1>
          <button onClick={()=>{setModal('novo');setForm({plano:'basico',limite_processos:500,limite_usuarios:50,vencimento_dia:10,tipo_orgao:'prefeitura'})}}
            style={{ padding:'8px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>+ Novo órgão</button>
        </div>
        <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="Buscar por nome ou município..." style={{ width:'100%', padding:'8px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, marginBottom:16, boxSizing:'border-box' }} />
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {orgaosFiltrados.map(o=>{
            const plano=PLANOS[o.plano]||PLANOS.basico
            return(
              <div key={o.id} style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:'16px 20px' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:44, height:44, borderRadius:8, background:'#E6F1FB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:700, color:'#185FA5', flexShrink:0 }}>{o.estado}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2 }}>
                      <div style={{ fontSize:14, fontWeight:500 }}>{o.nome}</div>
                      {o.suspensa&&<span style={{ background:'#FCEBEB', color:'#791F1F', padding:'1px 8px', borderRadius:99, fontSize:10, fontWeight:500 }}>Suspenso</span>}
                      <Badge bg={plano.bg} cor={plano.cor}>{plano.label}</Badge>
                    </div>
                    <div style={{ fontSize:12, color:'#9ca3af' }}>{o.municipio}/{o.estado} · {o.total_processos} processos · {o.total_usuarios} usuários</div>
                  </div>
                  <div style={{ display:'flex', gap:6, flexDirection:'column', alignItems:'flex-end' }}>
                    <button onClick={()=>verDetalhe(o)} style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>Ver detalhe</button>
                    {o.suspensa
                      ?<button onClick={()=>reativar(o.id)} style={{ padding:'6px 12px', border:'1px solid #bbf7d0', borderRadius:6, fontSize:12, cursor:'pointer', background:'#f0fdf4', color:'#15803d' }}>Reativar</button>
                      :<button onClick={()=>{setOrgaoAtivo(o);setModal('suspender')}} style={{ padding:'6px 12px', border:'1px solid #fecaca', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#dc2626' }}>Suspender</button>
                    }
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </>}

      {tela==='detalhe' && <>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:20 }}>
          <span onClick={()=>setTela('orgaos')} style={{ fontSize:13, color:'#6b7280', cursor:'pointer' }}>← Órgãos</span>
          <span style={{ color:'#e5e7eb' }}>›</span>
          <span style={{ fontSize:13, fontWeight:500 }}>{orgaoAtivo?.nome}</span>
        </div>
        {!detalhe
          ?<div style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>Carregando...</div>
          :<>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:16, marginBottom:20 }}>
              <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20, gridColumn:'1/3' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
                  <div>
                    <div style={{ fontSize:16, fontWeight:600 }}>{detalhe.orgao.nome}</div>
                    <div style={{ fontSize:13, color:'#9ca3af' }}>{detalhe.orgao.municipio}/{detalhe.orgao.estado}</div>
                  </div>
                  <div style={{ display:'flex', gap:6 }}>
                    <button onClick={()=>{setModal('editar');setForm({...detalhe.orgao})}} style={{ padding:'6px 12px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>Editar</button>
                    <button onClick={()=>setModal('admin')} style={{ padding:'6px 12px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>+ Admin</button>
                    {detalhe.orgao.suspensa
                      ?<button onClick={()=>reativar(detalhe.orgao.id)} style={{ padding:'6px 12px', border:'1px solid #bbf7d0', borderRadius:6, fontSize:12, cursor:'pointer', background:'#f0fdf4', color:'#15803d' }}>Reativar</button>
                      :<button onClick={()=>setModal('suspender')} style={{ padding:'6px 12px', border:'1px solid #fecaca', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#dc2626' }}>Suspender</button>
                    }
                  </div>
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12 }}>
                  {[['Plano',PLANOS[detalhe.orgao.plano]?.label||'—'],['Mensalidade',`R$ ${(detalhe.orgao.valor_mensalidade||0).toLocaleString('pt-BR')}`],['Vencimento',`Dia ${detalhe.orgao.vencimento_dia||10}`],['Contato',detalhe.orgao.contato_nome||'—'],['E-mail',detalhe.orgao.contato_email||'—'],['Slug',detalhe.orgao.slug]].map(([l,v])=>(
                    <div key={l}><div style={{ fontSize:11, color:'#9ca3af' }}>{l}</div><div style={{ fontSize:13, fontWeight:500, marginTop:1 }}>{v}</div></div>
                  ))}
                </div>
              </div>
              <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
                <div style={{ fontSize:13, fontWeight:500, marginBottom:14 }}>Métricas</div>
                {detalhe.storage && (
                  <div style={{ background:'#f9fafb', borderRadius:8, padding:12, marginBottom:12 }}>
                    <div style={{ fontSize:11, color:'#9ca3af', marginBottom:6 }}>📦 Armazenamento</div>
                    <div style={{ fontSize:18, fontWeight:600, color:'#185FA5' }}>
                      {detalhe.storage.gb < 1 ? `${detalhe.storage.mb} MB` : `${detalhe.storage.gb} GB`}
                    </div>
                    <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>
                      {detalhe.storage.docs} documento{detalhe.storage.docs!==1?'s':''} · limite {detalhe.storage.limite_mb >= 1024 ? `${(detalhe.storage.limite_mb/1024).toFixed(0)} GB` : `${detalhe.storage.limite_mb} MB`}
                    </div>
                    <div style={{ marginTop:8, background:'#e5e7eb', borderRadius:99, height:6, overflow:'hidden' }}>
                      <div style={{ height:'100%', borderRadius:99, background: detalhe.storage.mb/detalhe.storage.limite_mb > 0.8 ? '#dc2626' : '#185FA5', width:`${Math.min(100,(detalhe.storage.mb/detalhe.storage.limite_mb)*100).toFixed(0)}%` }} />
                    </div>
                    <div style={{ fontSize:10, color:'#9ca3af', marginTop:3 }}>
                      {((detalhe.storage.mb/detalhe.storage.limite_mb)*100).toFixed(1)}% utilizado
                    </div>
                  </div>
                )}
                {[['Total processos',detalhe.stats.total],['Abertos',detalhe.stats.abertos],['Concluídos',detalhe.stats.concluidos],['Hoje',detalhe.stats.hoje],['Este mês',detalhe.stats.esse_mes],['Atrasados +7d',detalhe.stats.atrasados]].map(([l,v])=>(
                  <div key={l} style={{ display:'flex', justifyContent:'space-between', padding:'4px 0', borderBottom:'1px solid #f9fafb', fontSize:13 }}>
                    <span style={{ color:'#6b7280' }}>{l}</span>
                    <span style={{ fontWeight:500, color:l==='Atrasados +7d'&&v>0?'#dc2626':'#111' }}>{v}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
              <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
                <div style={{ fontSize:13, fontWeight:500, marginBottom:14 }}>Usuários ({detalhe.usuarios.length})</div>
                {detalhe.usuarios.length===0
                  ?<div style={{ textAlign:'center', padding:16, color:'#9ca3af', fontSize:13 }}>Nenhum usuário.</div>
                  :detalhe.usuarios.map((u,i)=>(
                    <div key={u.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 0', borderBottom:i<detalhe.usuarios.length-1?'1px solid #f3f4f6':'none' }}>
                      <div style={{ width:32, height:32, borderRadius:'50%', background:'#E6F1FB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:600, color:'#185FA5', flexShrink:0 }}>{u.nome.substring(0,2).toUpperCase()}</div>
                      <div style={{ flex:1 }}>
                        <div style={{ fontSize:13, fontWeight:500 }}>{u.nome}</div>
                        <div style={{ fontSize:11, color:'#9ca3af' }}>{u.email}</div>
                      </div>
                      <span style={{ background:u.perfil==='admin'?'#E6F1FB':'#f3f4f6', color:u.perfil==='admin'?'#185FA5':'#374151', padding:'2px 8px', borderRadius:99, fontSize:10 }}>{u.perfil}</span>
                      <div style={{ display:'flex', gap:4 }}>
                        <button onClick={()=>editarAdmin(u)} style={{ padding:'3px 8px', border:'1px solid #d1d5db', borderRadius:6, fontSize:11, cursor:'pointer', background:'white' }}>Editar</button>
                        <button onClick={()=>resetarSenhaAdmin(u.id)} style={{ padding:'3px 8px', border:'1px solid #fef08a', borderRadius:6, fontSize:11, cursor:'pointer', background:'#fefce8', color:'#854d0e' }}>🔑 Senha</button>
                        <button onClick={()=>excluirAdmin(u.id)} style={{ padding:'3px 8px', border:'1px solid #fecaca', borderRadius:6, fontSize:11, cursor:'pointer', background:'white', color:'#dc2626' }}>✕</button>
                      </div>
                    </div>
                  ))
                }
              </div>
              <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
                <div style={{ fontSize:13, fontWeight:500, marginBottom:14 }}>Últimos processos</div>
                {detalhe.ultimos_processos.length===0
                  ?<div style={{ textAlign:'center', padding:16, color:'#9ca3af', fontSize:13 }}>Nenhum processo.</div>
                  :detalhe.ultimos_processos.map((p,i)=>(
                    <div key={p.numero} style={{ padding:'8px 0', borderBottom:i<detalhe.ultimos_processos.length-1?'1px solid #f3f4f6':'none' }}>
                      <div style={{ fontFamily:'monospace', fontSize:11, color:'#185FA5' }}>{p.numero}</div>
                      <div style={{ fontSize:12, color:'#374151', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.assunto}</div>
                      <div style={{ fontSize:11, color:'#9ca3af' }}>{new Date(p.aberto_em).toLocaleDateString('pt-BR')} · {p.status}</div>
                    </div>
                  ))
                }
              </div>
            </div>
          </>
        }
      </>}
    </SaLayout>
  )
}
